// Constants for local storage
export const ACTIVE_CHAT_KEY = "giojoy_active_chat";